/**
 * Every list this app reads can page. A partial read would silently drop
 * contacts or early messages out of a conversation, so this follows `cursor`
 * while `has_more` is true and hands back the whole set once, rather than a
 * page for the caller to manage.
 */
export async function fetchAllPages(get, path) {
  let items = [];
  let cursor;
  let permittedTags = null;
  let declaredTags = null;
  let pages = 0;
  for (;;) {
    const params = cursor ? { limit: 200, cursor } : { limit: 200 };
    const page = await get(path, params);
    items = items.concat(page.items || []);
    if (permittedTags === null) permittedTags = page.permitted_tags || [];
    if (declaredTags === null) declaredTags = page.declared_tags || null;
    pages += 1;
    if (!page.has_more || !page.cursor || pages > 500) break;
    cursor = page.cursor;
  }
  return { items, permittedTags, declaredTags };
}
